import React, {useState, useEffect} from 'react';
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import {format, fromUnixTime} from 'date-fns';
import {es} from 'date-fns/locale';
import { ReactComponent as IconoDetalle } from './../imagenes/detalle.svg';
import { ReactComponent as IconoEditar } from './../imagenes/editar.svg';
import { ReactComponent as IconoBorrar } from './../imagenes/borrar.svg';
import { ReactComponent as IconoHora } from './../imagenes/hora.svg';
import { ReactComponent as IconoCliente } from './../imagenes/cliente.svg';
import { ReactComponent as IconoEstado } from './../imagenes/estado.svg';
import useObtenerViajesTerminados from './../hooks/useObtenerViajesTerminados';
import {Header, Titulo, ContenedorHeader, ContenedorBotones} from './../elementos/Header';
import BotonCerrarSesion from "./../elementos/BotonCerrarSesion";
import {
  Input2,
  Input,
  Lista,
  ElementoLista,
  Descripcion,
  Fecha,
  BotonAccion,
  BotonCargarMas,
  ContenedorBotonCentral,
  ContenedorSubtitulo,
  Subtitulo,
  Boton,
  ContenedorFiltros,
  ContenedorFiltroMoviles,
  ContenedorFiltroBusqueda,
  ContenedorTotal,
  ContenedorSubtituloPequeño,
  ContenedorFiltrosTerminados,
  ContenedorInputconLabel,
  ContenedorFiltrosActivos,
  ContenedorNavegador,
  BotonNavegador
} from './../elementos/ElementosApp';
import { useAuth } from './../contextos/AuthContext';
import SelectPasajeros from './../componentes/SelectPasajeros'
import SelectClientesFiltro from './SelectClientesFiltro';
import SelectMovilesFiltro from './SelectMovilesFiltro';
import SelectEstadoTraslado from './SelectEstadoTraslado';
import IconoMovilEstado from "./../elementos/IconoEstado";
import BtnRegresar from "../elementos/BtnRegresar";
import DateTimePicker from './DateTimePricker';
import {db} from '../firebase/firebaseConfig';
import { ref, query, onValue,orderByChild,startAt,endAt,update} from "firebase/database";

import useObtenerClientes from "./../hooks/useObtenerClientes";
import useObtenerConductores from './../hooks/useObtenerConductores';
import ReactExport from "react-export-excel";
import useObtenerAdmin from './../hooks/useObtenerAdmin'
import useObtenerAdministradores from './../hooks/useObtenerAdministradores'
import {signOut} from 'firebase/auth';
import Swal from 'sweetalert2';
import {auth} from '../firebase/firebaseConfig';
import {useNavigate} from 'react-router-dom';


const  TrasladosTerminados = () => {

  const ExcelFile = ReactExport.ExcelFile;
  const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
  const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;
    const [viajes, cambiarViajes] = useState([]);
    const [fechaActual, cambiarFechaActual] = useState (new Date());
    const [fechaInicio, cambiarFechaInicio] = useState (new Date());//useState ('Ingrese Fecha y hora Inicio');
    const [fechaFin, cambiarFechaFin] = useState (new Date());//useState ('Ingrese Fecha y hora Fin');
    const [viajesordenadorfecha, cambiarviajesordenadorfecha] = useState([]);
    const [baseDesarga, cambiarbaseDesarga] = useState([]);
    const [filtroEstado, cambiarfiltroEstado] = useState ('TODOS');
    const [filtroServicio, cambiarFiltroServicio] = useState ('TODOS');
    const [filtroMovil, cambiarFiltroMovil] = useState ('TODOS');
    const [fechaActualp, cambiarFechaActualP] = useState (new Date());
    const {usuario} = useAuth();
    const navigate = useNavigate();
    var serviciosAsignados = [];
    var movilesAsignados = [];
    var trasladosDescargas = [];
    var Sube = '';
    var Baja = '';
    var Ubicado = '';
    var Duracion = '';
    var Lat_sub = '';
    var Long_sub = '';
    var Lat_baj = '';
    var Long_baj = '';
    var clientesfiltro = {};

    const [viajeFiltro, cambiarViajeFiltro] = useState ([]);
    const [muestraResultado, cambiarMuestraResultado] = useState(true);
    const formatearFechaxls = (fecha) => {
          return format(fromUnixTime(fecha), "dd'-'MM'-'yyyy", {locale: es})
      }
    const formatearFecha = (fecha) => {
        return format(fromUnixTime(fecha), "dd 'de' MMMM 'de' yyyy", {locale: es})
    }  
    const formatearHora = (fecha) => {
          return format(fromUnixTime(fecha), "HH':'mm'", {locale: es})
      }
  
     const formatearFecha_Hora = (fecha) => {
        return format(fromUnixTime(fecha), "dd'-'MM'-'yyyy' 'HH':'mm'", {locale: es})
    }

    function toTimestamp(strDate){
      var datum = Date.parse(strDate);
      return datum;
   }

   const [TipoUsuario, cambiarTipoUsuario] = useState([]);
   const uid = usuario.uid
   const UsarioLog = useObtenerAdmin({uid});
   const Administradores = useObtenerAdministradores();
   const Conductores = useObtenerConductores();
   const [Escliente, cambiarEscliente] = useState(true);



 
 useEffect (()=>{    
  if (UsarioLog.cliente === 'undefined' || UsarioLog.cliente === 'Sin Permisos' || UsarioLog.cliente === null)
  {cambiarTipoUsuario('salir')}
  else
  {    
    if (UsarioLog.cliente === 'R.T ESTRELLA' || UsarioLog.cliente === 'R.T Estrella')
      {cambiarTipoUsuario('admin')}
    else
      {
        if (Number(UsarioLog.numero) > 0)
        {{cambiarTipoUsuario('conductor')}
      }
        else{
          {cambiarTipoUsuario('cliente')}
      }
       
      }
  }
 },[UsarioLog]);
 
 
 useEffect (()=>{    
   
  if (UsarioLog.cliente === 'R.T ESTRELLA' || UsarioLog.cliente === 'R.T Estrella')
  {cambiarTipoUsuario('admin')
  console.log('entra admin')
  cambiarEscliente(false)
  cambiarFiltroServicio('TODOS')
}
else
  {{cambiarTipoUsuario('cliente')}
  console.log('entra cliente')
  console.log(UsarioLog.cliente)
  if (UsarioLog.cliente==='Grupo Mutual'){cambiarFiltroServicio('TODOS')} else {cambiarFiltroServicio(UsarioLog.cliente)}
}
if (Number(UsarioLog.numero) > 0)
{cambiarTipoUsuario('conductor')
console.log('entra conductor')
cambiarEscliente(false)
cambiarFiltroServicio('TODOS')
cambiarFiltroMovil(Number(UsarioLog.numero))
} 

 },[UsarioLog]);


   const onClickBuscar = async (e) => {
    e.preventDefault();
    cambiarViajes([]);
    cambiarMuestraResultado(false)
    const consulta = query(ref(db, 'projects/proj_6wVhReGA6EM5z4Jew4js7T/data/traslados'),orderByChild('fecha_hora_programada'),startAt(toTimestamp(fechaInicio)),endAt(toTimestamp(fechaFin)));
    console.log("llama base de viajes");
    return onValue(consulta, (snapshot) => {
           snapshot.forEach((childSnapshot) => {
            const childKey = childSnapshot.key;
            const childData = childSnapshot.val();
            cambiarViajes((viajes) => [...viajes, {...childData, id: childKey}]);
            });
    },{
        onlyOnce: true
      }
    )  
  }

  useEffect(() => {
    if (UsarioLog.hasOwnProperty("numero")){
      const viajesfiltroTerminado = viajes.filter(item => Number(item.numero_m) === Number(UsarioLog.numero))
      cambiarviajesordenadorfecha(viajesfiltroTerminado.sort((a, b) => (a.fecha_hora_programada < b.fecha_hora_programada ? 1 : a.fecha_hora_programada > b.fecha_hora_programada ? -1 : 0)))
    } 
    else{
    if (TipoUsuario==='cliente'){
      if (UsarioLog.cliente==='Grupo Mutual'){  
        let mutuales = ['Mutual Agustinas ','Mutual De Seguridad','Mutual Enea','Mutual La Florida','Mutual Lo Espejo','Mutual Maipu','Mutual Paine','Mutual Providencia','Mutual Puente Alto','Mutual Quilicura','MUTUAL SAM615','Mutual San Bernardo','Mutual Talagante']
                
    const viajesfiltroTerminado = viajes.filter(item =>  mutuales.includes(item.empresa))
    cambiarviajesordenadorfecha(viajesfiltroTerminado.sort((a, b) => (a.fecha_hora_programada < b.fecha_hora_programada ? 1 : a.fecha_hora_programada > b.fecha_hora_programada ? -1 : 0)))
  } else {
    const viajesfiltroTerminado = viajes.filter(item => item.empresa === UsarioLog.cliente)
    cambiarviajesordenadorfecha(viajesfiltroTerminado.sort((a, b) => (a.fecha_hora_programada < b.fecha_hora_programada ? 1 : a.fecha_hora_programada > b.fecha_hora_programada ? -1 : 0)))

  }
  } else {
    cambiarviajesordenadorfecha(viajes.sort((a, b) => (a.fecha_hora_programada < b.fecha_hora_programada ? 1 : a.fecha_hora_programada > b.fecha_hora_programada ? -1 : 0)))
    
  }}

  }, [viajes]);

  
  useEffect(() => {
    cambiarViajeFiltro(viajesordenadorfecha)
   
  }, [viajesordenadorfecha]);
  useEffect(() => {
  trasladosDescargas = [];
  viajeFiltro.map((viaje) => {
        if(viaje.hasOwnProperty("pasajeros")){
        let pasajeros = Object.keys(viaje.pasajeros).map(function (key) {return {id : key, ...viaje.pasajeros[key]};})
        let UsuarioCreador = "Sin Definir"
        let UsuarioModificador = "Sin Definir"
        
        if(Administradores.find((usuario) => usuario.id === viaje.creador)) {
          UsuarioCreador = Administradores.find((usuario) => usuario.id === viaje.creador);
          } else {
                  if(Conductores.find((usuario) => usuario.id === viaje.creador)) {
                    UsuarioCreador = Conductores.find((usuario) => usuario.id === viaje.creador);
                    } else {
                    UsuarioCreador = {id: viaje.creador, nombre: "Otro"}
                    }
          }

          
        if(Administradores.find((usuario) => usuario.id === viaje.modificador)) {
            UsuarioModificador = Administradores.find((usuario) => usuario.id === viaje.modificador);
            } else {
                    if(Conductores.find((usuario) => usuario.id === viaje.modificador)) {
                      UsuarioModificador = Conductores.find((usuario) => usuario.id === viaje.modificador);
                      } else {
                        UsuarioModificador = {id: viaje.modificador, nombre: "Otro"}
                      }
            }
          
               let id_val= 1
        {pasajeros.map((pasajero) => {
          Ubicado = ''
          Sube = ''
          Baja = ''
          Duracion = ''
          if(viaje.hasOwnProperty("vale_c")){
            if (id_val !== viaje.id){
                let Pasajero_Nombre_v = ''
                let Folio_Traslado_v = '--'
                let TAG_v = 0
                let Estacionamiento_v = 0
                let Encargo_v = 0
                let Tarifa_fija_v = 0
                let Taximetro_v = 0
                let Total_v = 0
                let Kms_v = 0
                let minutos_v = 0

                
                if (pasajero.nombre === undefined){Pasajero_Nombre_v = ''}else{Pasajero_Nombre_v = pasajero.nombre.toUpperCase()}
                if (viaje.folio === undefined){Folio_Traslado_v = ''}else{Folio_Traslado_v = viaje.folio.toUpperCase()}
                if (viaje.tag_c === undefined){TAG_v = 0}else{TAG_v = Number(viaje.tag_c)}
                if (viaje.estacionamiento_c === undefined){Estacionamiento_v = 0}else{Estacionamiento_v = Number(viaje.estacionamiento_c)}
                if (viaje.encargo_c === undefined){Encargo_v = 0}else{Encargo_v = (Number(viaje.encargo_c))}
                if (pasajero.fechahora_ubi === undefined){Ubicado = ''}else{Ubicado = formatearFecha_Hora(pasajero.fechahora_ubi/1000)}
                if (pasajero.fechahora_sub === undefined){Sube = ''}else{Sube = formatearFecha_Hora(pasajero.fechahora_sub/1000)}
                if (pasajero.fechahora_baj === undefined){Baja = ''}else{Baja = formatearFecha_Hora(pasajero.fechahora_baj/1000)}
                if (pasajero.fechahora_ubi === undefined || pasajero.fechahora_baj === undefined ){
                    if (pasajero.fechahora_sub === undefined || pasajero.fechahora_baj === undefined )
                      {Duracion = ''}
                      else
                      {Duracion = (((Number(pasajero.fechahora_baj)/1000) - (Number(pasajero.fechahora_sub)/1000))/60)}
                    }
                  else
                  {Duracion = (((Number(pasajero.fechahora_baj)/1000) - (Number(pasajero.fechahora_ubi)/1000))/60)}
                if (pasajero.latitud_sub === undefined){Lat_sub = ''}else{Lat_sub = pasajero.latitud_sub}
                if (pasajero.longitud_sub === undefined){Long_sub = ''}else{Long_sub = pasajero.longitud_sub}
                if (pasajero.latitud_baj === undefined){Lat_baj = ''}else{Lat_baj = pasajero.latitud_baj}
                if (pasajero.longitud_baj === undefined){Long_baj = ''}else{Long_baj = pasajero.longitud_baj}
                if (viaje.tarifa_fija_c === undefined){Tarifa_fija_v = 0}else{Tarifa_fija_v = Number(viaje.tarifa_fija_c)}
                if (viaje.metros_c === undefined){Kms_v = 0}else{Kms_v = (Number(viaje.metros_c)/1000)}
                if (viaje.minutos_c === undefined){minutos_v = 0}else{minutos_v = (Number(viaje.minutos_c))}
                
               
                if (Tarifa_fija_v>0){
                  Taximetro_v = Tarifa_fija_v - (TAG_v + Estacionamiento_v)
                  Total_v = Tarifa_fija_v
                } else {
                  if ((viaje.tipo_m==='TaxiEjecutivo' || viaje.tipo_m==='Taxi_Ejecutivo' || viaje.tipo_m==='VAN' || viaje.tipo_m==='Van') && ((Kms_v > 0) || (minutos_v >0))) {
                    Taximetro_v = Math.ceil(((Kms_v*800)+(minutos_v*160)+2100))
                    Total_v = Math.ceil(Taximetro_v + TAG_v + Estacionamiento_v + Encargo_v)
                  } else {
                    if ((Kms_v > 0) || (minutos_v >0)){
                    Taximetro_v = Math.ceil(((Kms_v*850)+(minutos_v*170)+400))
                    Total_v = Math.ceil(Taximetro_v + TAG_v + Estacionamiento_v + Encargo_v)
                  }
                  }
                }


                trasladosDescargas = [...trasladosDescargas,{ 
                id_Viaje: viaje.id,
                Fecha: formatearFechaxls(viaje.fecha_hora_programada/1000),
                Hora: formatearHora(viaje.fecha_hora_programada/1000),
                Estado: viaje.estado,
                Movil: viaje.numero_m,
                Nombre_Movil: viaje.nombre_m,
                Patente_Movil: viaje.patente_m,
                Telefono_Movil: viaje.telefono_m,
                Color_Movil: viaje.color_m,
                Comentarios_Traslado: viaje.comentarios,
                Folio_Traslado: Folio_Traslado_v,
                KmsFolio_Traslado: viaje.kmfolio,
                Fecha_Creacion: formatearFechaxls(viaje.fecha_hora_creacion/1000),
                Hora_Creacion: formatearHora(viaje.fecha_hora_creacion/1000),
                Usuario_Creacion: UsuarioCreador.nombre,
                Fecha_Modificacion: formatearFecha(viaje.fecha_hora_modificacion/1000),
                Hora_Modificacion: formatearHora(viaje.fecha_hora_modificacion/1000),
                Usuario_Modificacion: UsuarioModificador.nombre,
                Empresa: viaje.empresa,
                Pasajero_Nombre : Pasajero_Nombre_v,
                Pasajero_Telefono: pasajero.telefono,
                Pasajero_Direccion_Origen: pasajero.direccion_o,
                Pasajero_RFC: pasajero.rfc,
                Pasajero_Empresa: pasajero.cliente,
                Pasajero_Direccion_Destino: pasajero.direccion_d,
                Pasajero_Fecha: formatearFechaxls(pasajero.fechahoraviajep/1000),
                Pasajero_Hora: formatearHora(pasajero.fechahoraviajep/1000),
                Pasajero_Comentario: pasajero.comentariop,
                Vale: viaje.vale_c,
                Metros: viaje.metros_c,
                KMS: Kms_v,
                Minutos: minutos_v,
                Taximetro: Taximetro_v,
                Tarifa_Fija: Number(viaje.tarifa_fija_c),
                TAG: Number(TAG_v),
                Estacionamiento: Number(Estacionamiento_v),
                Encargo: Number(Encargo_v),
                Tipo_Movil: viaje.tipo_m,
                Total: Total_v,
                Fecha_Hora_Ubi: Ubicado,
                Fecha_Hora_Sub: Sube,
                Fecha_hora_Baja: Baja,
                Duracion_Minutos: Duracion,
                Lat_Sub: pasajero.latitud_sub,
                Log_Sub: pasajero.longitud_sub,
                Lat_Baja: pasajero.longitud_baj,
                Log_Baja: pasajero.longitud_baj
              }
              ]
            }
            else{
              let Pasajero_Nombre_v = ''
              let Folio_Traslado_v = '--'
              if (pasajero.nombre === undefined){Pasajero_Nombre_v = ''}else{Pasajero_Nombre_v = pasajero.nombre.toUpperCase()}
              if (viaje.folio === undefined){Folio_Traslado_v = ''}else{Folio_Traslado_v = viaje.folio.toUpperCase()}

                trasladosDescargas = [...trasladosDescargas,{ id_Viaje: viaje.id,
                Fecha: formatearFechaxls(viaje.fecha_hora_programada/1000),
                Hora: formatearHora(viaje.fecha_hora_programada/1000),
                Estado: viaje.estado,
                Movil: viaje.numero_m,
                Nombre_Movil: viaje.nombre_m,
                Patente_Movil: viaje.patente_m,
                Telefono_Movil: viaje.telefono_m,
                Color_Movil: viaje.color_m,
                Comentarios_Traslado: viaje.comentarios,
                Folio_Traslado: Folio_Traslado_v,
                KmsFolio_Traslado: viaje.kmfolio,
                Fecha_Creacion: formatearFechaxls(viaje.fecha_hora_creacion/1000),
                Hora_Creacion: formatearHora(viaje.fecha_hora_creacion/1000),
                Usuario_Creacion: UsuarioCreador.nombre,
                Fecha_Modificacion: formatearFechaxls(viaje.fecha_hora_modificacion/1000),
                Hora_Modificacion: formatearHora(viaje.fecha_hora_modificacion/1000),
                Usuario_Modificacion: UsuarioModificador.nombre,
                Empresa: viaje.empresa,
                Pasajero_Nombre: Pasajero_Nombre_v,
                Pasajero_Telefono: pasajero.telefono,
                Pasajero_Direccion_Origen: pasajero.direccion_o,
                Pasajero_RFC: pasajero.rfc,
                Pasajero_Empresa: pasajero.cliente,
                Pasajero_Direccion_Destino: pasajero.direccion_d,
                Pasajero_Fecha: formatearFechaxls(pasajero.fechahoraviajep/1000),
                Pasajero_Hora: formatearHora(pasajero.fechahoraviajep/1000),
                Pasajero_Comentario: pasajero.comentariop,
                Vale: viaje.vale_c,
                Metros: '',
                KMS: '',
                Minutos: '',
                TAG: '',
                Estacionamiento: '',
                Encargo: '',
                Tipo_Movil: viaje.tipo_m,
                Total: '',
                Fecha_Hora_Ubi: Ubicado,
                Fecha_Hora_Sub: Sube,
                Fecha_hora_Baja: Baja,
                Duracion_Minutos: Duracion,
                Lat_Sub: pasajero.latitud_sub,
                Log_Sub: pasajero.longitud_sub,
                Lat_Baja: pasajero.longitud_baj,
                Log_Baja: pasajero.longitud_baj
              }
            ]
            }


          }else{
            let Pasajero_Nombre_v = ''
            let Folio_Traslado_v = '--'
            if (pasajero.nombre === undefined){Pasajero_Nombre_v = ''}else{Pasajero_Nombre_v = pasajero.nombre.toUpperCase()}
            if (viaje.folio === undefined){Folio_Traslado_v = ''}else{Folio_Traslado_v = viaje.folio.toUpperCase()}

              trasladosDescargas = [...trasladosDescargas,{ id_Viaje: viaje.id,
              Fecha: formatearFechaxls(viaje.fecha_hora_programada/1000),
              Hora: formatearHora(viaje.fecha_hora_programada/1000),
              Estado: viaje.estado,
              Movil: viaje.numero_m,
              Nombre_Movil: viaje.nombre_m,
              Patente_Movil: viaje.patente_m,
              Telefono_Movil: viaje.telefono_m,
              Color_Movil: viaje.color_m,
              Comentarios_Traslado: viaje.comentarios,
              Folio_Traslado: Folio_Traslado_v,
              KmsFolio_Traslado: viaje.kmfolio,
              Fecha_Creacion: formatearFechaxls(viaje.fecha_hora_creacion/1000),
              Hora_Creacion: formatearHora(viaje.fecha_hora_creacion/1000),
              Usuario_Creacion: UsuarioCreador.nombre,
              Fecha_Modificacion: formatearFechaxls(viaje.fecha_hora_modificacion/1000),
              Hora_Modificacion: formatearHora(viaje.fecha_hora_modificacion/1000),
              Usuario_Modificacion: UsuarioModificador.nombre,
              Empresa: viaje.empresa,
              Pasajero_Nombre: Pasajero_Nombre_v,
              Pasajero_Telefono: pasajero.telefono,
              Pasajero_Direccion_Origen: pasajero.direccion_o,
              Pasajero_RFC: pasajero.rfc,
              Pasajero_Empresa: pasajero.cliente,
              Pasajero_Direccion_Destino: pasajero.direccion_d,
              Pasajero_Fecha: formatearFechaxls(pasajero.fechahoraviajep/1000),
              Pasajero_Hora: formatearHora(pasajero.fechahoraviajep/1000),
              Pasajero_Comentario: pasajero.comentariop,
              Vale: 'Sin App',
              Metros: '',
              Minutos: '',
              KMS: '',
              TAG: '',
              Estacionamiento: '',
              Encargo: '',
              Tipo_Movil: viaje.tipo_m,
              Total: '',
              Fecha_Hora_Ubi: Ubicado,
              Fecha_Hora_Sub: Sube,
              Fecha_hora_Baja: Baja,
              Duracion_Minutos: Duracion,
              Lat_Sub: pasajero.latitud_sub,
              Log_Sub: pasajero.longitud_sub,
              Lat_Baja: pasajero.longitud_baj,
              Log_Baja: pasajero.longitud_baj
            }
]
          }
             id_val = viaje.id  
              }
              )
          }
        }
      
      }
      
      )
    cambiarbaseDesarga(trasladosDescargas)
    
  }, [viajeFiltro]);
  useEffect(() => {
    let mutuales = ['Mutual Agustinas ','Mutual De Seguridad','Mutual Enea','Mutual La Florida','Mutual Lo Espejo','Mutual Maipu','Mutual Paine','Mutual Providencia','Mutual Puente Alto','Mutual Quilicura','MUTUAL SAM615','Mutual San Bernardo','Mutual Talagante']
              


    if (filtroMovil === 'TODOS' && filtroServicio === 'TODOS' && filtroEstado === 'TODOS') {
      cambiarViajeFiltro(viajesordenadorfecha)
    } 
    if (filtroMovil !== 'TODOS' && filtroServicio === 'TODOS' && filtroEstado === 'TODOS') {
      cambiarViajeFiltro(viajesordenadorfecha.filter(item => Number(item.numero_m) === Number(filtroMovil)))
    }
    if  (filtroMovil === 'TODOS' && filtroServicio !== 'TODOS' && filtroEstado === 'TODOS') {
      cambiarViajeFiltro(viajesordenadorfecha.filter(item => item.empresa === filtroServicio))
    }
    if  (filtroMovil === 'TODOS' && filtroServicio === 'TODOS' && filtroEstado !== 'TODOS') {
      cambiarViajeFiltro(viajesordenadorfecha.filter(item => item.estado === filtroEstado))
    }
    if  (filtroMovil !== 'TODOS' && filtroServicio !== 'TODOS' && filtroEstado === 'TODOS') {
      cambiarViajeFiltro(viajesordenadorfecha.filter(item => (mutuales.includes(item.empresa) && Number(item.numero_m) === Number(filtroMovil))))
    }
    if  (filtroMovil !== 'TODOS' && filtroServicio === 'TODOS' && filtroEstado !== 'TODOS') {
      cambiarViajeFiltro(viajesordenadorfecha.filter(item => (item.estado === filtroEstado && Number(item.numero_m) === Number(filtroMovil))))
    }
    if  (filtroMovil === 'TODOS' && filtroServicio !== 'TODOS' && filtroEstado !== 'TODOS') {
      cambiarViajeFiltro(viajesordenadorfecha.filter(item => (item.estado === filtroEstado && mutuales.includes(item.empresa))))
    }
    if  (filtroMovil !== 'TODOS' && filtroServicio !== 'TODOS' && filtroEstado !== 'TODOS') {
      cambiarViajeFiltro(viajesordenadorfecha.filter(item => (item.estado === filtroEstado && mutuales.includes(item.empresa) && Number(item.numero_m) === Number(filtroMovil))))
    }
  }, [filtroMovil,filtroServicio,fechaActualp,filtroEstado]);

const moviles= useObtenerConductores();
  moviles.sort((a, b) => (Number(a.numero) > Number(b.numero) ? 1 : Number(a.numero) < Number(b.numero) ? -1 : 0))
  const movilesactivos = moviles.filter(item => item.estado === 'activo')
  movilesactivos.map((movil) => {
    var recuento = viajesordenadorfecha.reduce((contador, { numero_m }) => Number(numero_m) === Number(movil.numero) ? contador += 1 : contador, 0); // 6
    if (recuento>0){movilesAsignados = [...movilesAsignados,{numero_m: movil.numero, asignaciones: recuento}]}
})
 
const servicios= useObtenerClientes();
servicios.sort((a, b) => (a.nombrecorto > b.nombrecorto ? 1 : a.nombrecorto < b.nombrecorto ? -1 : 0))

servicios.map((servicio) => {
  var recuento = viajesordenadorfecha.reduce((contador, { empresa }) => empresa === servicio.nombrecorto ? contador += 1 : contador, 0); // 6
  if (recuento>0){serviciosAsignados = [...serviciosAsignados,{empresa: servicio.nombrecorto, asignaciones: recuento}]}
})

  const time = toTimestamp(fechaActual)
   
  const fechaEsIgual = (viajes,index,viaje) => {
          if(index !== 0){
            const fechaActual2 = formatearFecha(viaje.fecha_hora_programada/1000);
            const fechaAnterior = formatearFecha(viajes[index-1].fecha_hora_programada/1000);
  
            if(fechaActual2 === fechaAnterior){
              return true;
            } else {
              return false;
            }
          }
    }
  
    const fechaEsUrgente = (fecha_hora_programada,estado) => {
        const fechaActual3 = (toTimestamp(fechaActual))/1000
        const fechaProgramada = fecha_hora_programada/1000;
        const minutosRestantes = (fechaProgramada-fechaActual3)/60
        if(minutosRestantes <= 120 && estado ==='Programado'){
          return true;
        } else {
          return false;
        }
  }
  


// Cancela Viaje
const onClickRegularizaViaje = async (e) => {
  e.preventDefault();
  const input = document.getElementById('input'+e.target.value);
 var viaje_var =  viajesordenadorfecha.filter(item => item.id === e.target.value )
 
  console.log('entra a NO es clenrte')

  const { value: Empresa_C } = await Swal.fire({
    title: "¿Desea Cancelar Traslado?",
    text: 'Debes indicar el motivo de cancelación del traslado de las : ' + formatearHora((viaje_var[0].fecha_hora_programada)/1000),
    icon: 'warning',
    input: "select",
    inputOptions: {
      Clientes: {
        'Mutual Agustinas ' : 'Mutual Agustinas ',
        'Mutual De Seguridad': 'Mutual De Seguridad',
        'Mutual Enea': 'Mutual Enea',
        'Mutual La Florida': 'Mutual La Florida',
        'Mutual Lo Espejo': 'Mutual Lo Espejo',
        'Mutual Maipu': 'Mutual Maipu',
        'Mutual Paine': 'Mutual Paine',
        'Mutual Providencia': 'Mutual Providencia',
        'Mutual Puente Alto': 'Mutual Puente Alto',
        'Mutual Quilicura': 'Mutual Quilicura',
        'Mutual San Bernardo': 'Mutual San Bernardo',
        'Mutual Talagante': 'Mutual Talagante',
        'Cet Arauco': 'Cet Arauco'
      },
    },

    showCancelButton: true,
    cancelButtonText: 'No',
    confirmButtonText: 'Si',
    confirmButtonColor: "blue",
    inputValidator: (value) => {
      if (!value) {
        return "Debes escribir motivo de cancelacion";
      }
    }
  });
  if (Empresa_C) {
    console.log('Cancela traslado')
    console.log(Empresa_C)
    console.log(e.target.value)
    console.log(viaje_var[0].estado)
    if (e.target.value !== '' || e.target.value !== 'undefined'){

      update(ref(db,`projects/proj_6wVhReGA6EM5z4Jew4js7T/data/traslados/${e.target.value}`),
         {empresa: Empresa_C
         })  

      let indiceElemento = viajeFiltro.findIndex(el => el.id === e.target.value )
      viajes[indiceElemento] = {...viajeFiltro[indiceElemento], 
      empresa: Empresa_C    
      }
      //const input = document.getElementById('input'+e.target.value);
      input.value = Empresa_C
      input.disabled = true
 }
    Swal.fire(`Empresa Asignada`);
  }
}
// Fin Cancela Viaje





  useEffect(() => {
    const timer = setTimeout(() => {
      cambiarFechaActual(new Date()); 
    }, 3600000);
    return () => clearTimeout(timer);
  }, [fechaActual]);

  return ( 
        <>
        <Helmet>
        <title>Busqueda Traslados</title>
        </Helmet>
            <Header>
            <ContenedorNavegador>
      <BtnRegresar></BtnRegresar>
      <BotonNavegador to="/listar-activos">Listar</BotonNavegador>
      <BotonNavegador to="/crear-viaje">Crear</BotonNavegador>
      </ContenedorNavegador>           
                <Titulo>Busqueda Traslados</Titulo>         
            </Header>

        <ContenedorTotal>
        <ContenedorFiltroBusqueda>
             <ContenedorFiltrosTerminados>
             <ContenedorInputconLabel><p>Selecciones Fecha Desde</p><DateTimePicker fechahoraviaje={fechaInicio} cambiarFechahoraviaje={cambiarFechaInicio}/></ContenedorInputconLabel>  
             <ContenedorInputconLabel><p>Selecciones Fecha Hasta</p><DateTimePicker fechahoraviaje={fechaFin} cambiarFechahoraviaje={cambiarFechaFin}/></ContenedorInputconLabel>  
             <Boton onClick={onClickBuscar}>Buscar</Boton>
             </ContenedorFiltrosTerminados>
             <div hidden={muestraResultado}>
             <ContenedorFiltrosActivos>
             <ContenedorInputconLabel><p>Filtro de Estado</p><SelectEstadoTraslado filtroEstado={filtroEstado} cambiarfiltroEstado={cambiarfiltroEstado}></SelectEstadoTraslado></ContenedorInputconLabel>
            
             {(UsarioLog.hasOwnProperty("numero"))//(viaje.pasajeros === null || viaje.pasajeros === 'undefined') 
                    ? <ContenedorInputconLabel><p>Filtro de Moviles</p><Input2 name="movil" type="text" placeholder="Movil" value={UsarioLog.numero} disabled = {true}/></ContenedorInputconLabel>
                    : <ContenedorInputconLabel><p>Filtro de Moviles</p><SelectMovilesFiltro filtroMovil={filtroMovil} cambiarFiltroMovil={cambiarFiltroMovil} moviles={movilesAsignados}/></ContenedorInputconLabel>
                    }

             {!(Escliente) 
                      ? <ContenedorInputconLabel><p>Filtro de Servicios</p><SelectClientesFiltro filtroServicio={filtroServicio} cambiarFiltroServicio={cambiarFiltroServicio} servicios={serviciosAsignados}/></ContenedorInputconLabel> 
                      : (UsarioLog.cliente==='Grupo Mutual') 
                      ? <ContenedorInputconLabel><p>Filtro de Servicios</p><SelectClientesFiltro filtroServicio={filtroServicio} cambiarFiltroServicio={cambiarFiltroServicio} servicios={serviciosAsignados}/></ContenedorInputconLabel> 
                      : <ContenedorInputconLabel><p>Empresa</p><Input2 name="empresa" type="text" placeholder="Empresa" value={filtroServicio} disabled = {true}/></ContenedorInputconLabel>
                    }



             <div hidden={!Escliente}>
             <ExcelFile filename="TrasladosRTE" element={<Boton>Descargar</Boton>}>
                <ExcelSheet data={baseDesarga} name="Traslados">
                <ExcelColumn label="Pasajero Fecha" value="Pasajero_Fecha"/>
                <ExcelColumn label="Pasajero Hora" value="Pasajero_Hora"/>
                <ExcelColumn label="Pasajero Nombre" value="Pasajero_Nombre"/>    
                <ExcelColumn label="Pasajero Teléfono" value="Pasajero_Telefono"/>
                <ExcelColumn label="Pasajero Dirección Origen" value="Pasajero_Direccion_Origen"/>
                <ExcelColumn label="Pasajero Dirección Destino" value="Pasajero_Direccion_Destino"/>
                <ExcelColumn label="Pasajero RFC" value="Pasajero_RFC"/>    
                <ExcelColumn label="Folio Traslado" value="Folio_Traslado"/>
                <ExcelColumn label="KmsFolio Traslado" value="KmsFolio_Traslado"/>    
                <ExcelColumn label="Pasajero Empresa" value="Pasajero_Empresa"/>
                <ExcelColumn label="Móvil" value="Movil"/>
                <ExcelColumn label="N° Vale" value="Vale"/>
                <ExcelColumn label="KMS" value="KMS"/>
                <ExcelColumn label="Minutos" value="Minutos"/>           
                <ExcelColumn label="Taxímetro" value="Taximetro"/> 
                <ExcelColumn label="TAG" value="TAG"/>
                <ExcelColumn label="Estacionamiento" value="Estacionamiento"/>
                <ExcelColumn label="Serv. Encargo" value="Encargo"/>
                <ExcelColumn label="Total" value="Total"/>    
                <ExcelColumn label="Pasajero Comentario" value="Pasajero_Comentario"/>
                <ExcelColumn label="id_Viaje" value="id_Viaje"/>
                <ExcelColumn label="Fecha" value="Fecha"/>
                <ExcelColumn label="Hora" value="Hora"/>
                <ExcelColumn label="Estado" value="Estado"/>
                </ExcelSheet>
                </ExcelFile>
            </div>
            <div hidden={Escliente}>
             <ExcelFile filename="TrasladosRTE" element={<Boton>Descargar</Boton>}>
                <ExcelSheet data={baseDesarga} name="Traslados">
                <ExcelColumn label="Pasajero Fecha" value="Pasajero_Fecha"/>
                <ExcelColumn label="Pasajero Hora" value="Pasajero_Hora"/>
                <ExcelColumn label="Pasajero Nombre" value="Pasajero_Nombre"/>    
                <ExcelColumn label="Pasajero Teléfono" value="Pasajero_Telefono"/>
                <ExcelColumn label="Pasajero Dirección Origen" value="Pasajero_Direccion_Origen"/>
                <ExcelColumn label="Pasajero Dirección Destino" value="Pasajero_Direccion_Destino"/>
                <ExcelColumn label="Pasajero RFC" value="Pasajero_RFC"/>    
                <ExcelColumn label="Folio Traslado" value="Folio_Traslado"/>
                <ExcelColumn label="KmsFolio Traslado" value="KmsFolio_Traslado"/>    
                <ExcelColumn label="Pasajero Empresa" value="Pasajero_Empresa"/>
                <ExcelColumn label="Móvil" value="Movil"/>
                <ExcelColumn label="N° Vale" value="Vale"/>
                <ExcelColumn label="KMS" value="KMS"/>
                <ExcelColumn label="Minutos" value="Minutos"/>           
                <ExcelColumn label="Taxímetro" value="Taximetro"/> 
                <ExcelColumn label="TAG" value="TAG"/>
                <ExcelColumn label="Estacionamiento" value="Estacionamiento"/>
                <ExcelColumn label="Serv. Encargo" value="Encargo"/>
                <ExcelColumn label="Total" value="Total"/>    
                <ExcelColumn label="Pasajero Comentario" value="Pasajero_Comentario"/>
                <ExcelColumn label="id_Viaje" value="id_Viaje"/>
                <ExcelColumn label="Tarija_Fija" value="Tarifa_Fija"/>
                <ExcelColumn label="Fecha" value="Fecha"/>
                <ExcelColumn label="Hora" value="Hora"/>
                <ExcelColumn label="Estado" value="Estado"/>
                <ExcelColumn label="Fecha Creación" value="Fecha_Creacion"/>
                <ExcelColumn label="Hora Creación" value="Hora_Creacion"/>
                <ExcelColumn label="Usuario Creación" value="Usuario_Creacion"/>
                <ExcelColumn label="Fecha Modificación" value="Fecha_Modificacion"/>
                <ExcelColumn label="Hora Modificación" value="Hora_Modificacion"/>
                <ExcelColumn label="Usuario Modificación" value="Usuario_Modificacion"/>
                <ExcelColumn label="Empresa" value="Empresa"/>
                <ExcelColumn label="Móvil" value="Movil"/>
                <ExcelColumn label="Patente Móvil" value="Patente_Movil"/>
                <ExcelColumn label="Tipo Móvil" value="Tipo_Movil"/>
                <ExcelColumn label="Teléfono Móvil" value="Telefono_Movil"/>
                <ExcelColumn label="Color Móvil" value="Color_Movil"/>
                <ExcelColumn label="Nombre Móvil" value="Nombre_Movil"/>
                <ExcelColumn label="Comentarios Traslado" value="Comentarios_Traslado"/>
                <ExcelColumn label="Fecha Hora Ubicado" value="Fecha_Hora_Ubi"/>
                <ExcelColumn label="Fecha Hora Sube" value="Fecha_Hora_Sub"/>
                <ExcelColumn label="Fecha Hora Baja" value="Fecha_hora_Baja"/>
                <ExcelColumn label="Minutos Duracion" value="Duracion_Minutos"/>
                </ExcelSheet>
                </ExcelFile>
            </div>
             </ContenedorFiltrosActivos>
             </div>
        </ContenedorFiltroBusqueda>
             <div>         
          <div hidden={muestraResultado}>
            <Lista>
          {viajeFiltro.map((viaje,index) => {
               return(
               <div key={viaje.id}>
                {!fechaEsIgual(viajeFiltro,index,viaje) && <Fecha>{formatearFecha((viaje.fecha_hora_programada)/1000)}</Fecha>}
               
                 <ElementoLista key={viaje.id}>
                    <ContenedorBotones>
                    <BotonAccion as={Link} to={`/detalle-viaje/${viaje.id}`}>
                        <IconoDetalle/>
                      </BotonAccion>

                    </ContenedorBotones>
                    {!fechaEsUrgente(viaje.fecha_hora_programada,viaje.estado) 
                    ? <Descripcion  ><IconoHora/>&nbsp;{formatearHora((viaje.fecha_hora_programada)/1000)} </Descripcion>
                    : <Descripcion  style={{backgroundColor: "red"}}><IconoHora/>&nbsp;{formatearHora((viaje.fecha_hora_programada)/1000)} </Descripcion>
                    }
                    {(viaje.empresa===true) 
                    ? <Descripcion><IconoMovilEstado estado={viaje.estado}/>&nbsp;{viaje.numero_m}&nbsp;&nbsp;{viaje.estado}&nbsp;<Input2 id ={'input'+viaje.id} value={viaje.empresa} ></Input2> <BotonAccion name="regulariza_viaje" value={viaje.id} onClick={onClickRegularizaViaje}> R </BotonAccion></Descripcion>
                    : <Descripcion><IconoMovilEstado estado={viaje.estado}/>&nbsp;{viaje.numero_m}&nbsp;&nbsp;{viaje.estado}&nbsp; &nbsp;{!(viaje.empresa ==='METRO' || viaje.empresa ==='Metro')  ? <div>&nbsp; &nbsp;{viaje.empresa}</div> : <div> &nbsp;&nbsp;Folio : &nbsp;{viaje.folio}</div>} </Descripcion>
                    
                    }
                    {!(viaje.hasOwnProperty("pasajeros"))//(viaje.pasajeros === null || viaje.pasajeros === 'undefined') 
                    ? <></>
                    : <SelectPasajeros pasajeros = {viaje.pasajeros}/>
                    }

                </ElementoLista>
                </div>)
          })}

          {viajes.length === 0 &&
					<ContenedorSubtitulo>
						<Subtitulo>Sin registros para mostrar</Subtitulo>
					</ContenedorSubtitulo>
				}
          </Lista>   
            </div>
            </div>
            </ContenedorTotal>   
    </>
  );
}

export default  TrasladosTerminados;